import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';
import { ModReservasComponent } from './components/mod-reservas/mod-reservas.component';
import { ModCanchasComponent } from './components/mod-canchas/mod-canchas.component';
import { LoginComponent } from './components/login/login.component';
import { LogoutComponent } from './components/login/logout.component';
import { AuthGuard } from './_helpers/auth.guard';
import { ModSorteosComponent } from './components/mod-sorteos/mod-sorteos.component';
import { ModPlayersComponent } from './components/mod-players/mod-players.component';
import { PlayerComponent } from './components/player/player.component';
import { ModReservasListComponent } from './components/mod-reservas-list/mod-reservas-list.component';
import { FeedbackMain } from './components/feedback/main/feedbackMain.component';

// Giveaways
import { GiveawayDetailComponent } from './components/mod-sorteos/giveaway-detail/giveaway-detail.component';

// Health
import { HealthComponent } from './components/health/health-list.component';
import { HealthDetailComponent } from './components/health/health-detail/health-detail.component';

// Tournaments
import { TournamentsListComponent } from './components/tournaments-list/tournaments-list.component';
import { CreateTournamentComponent } from './components/tournaments-list/create-tournament/create-tournament.component';
import { TournamentDetailComponent } from './components/tournaments-list/tournament-detail/tournament-detail.component';

const routes: Routes = [
  { path: 'login', component: LoginComponent },
  { path: 'logout', component: LogoutComponent },

  {
    path: 'reservas',
    component: ModReservasComponent,
    canActivate: [AuthGuard],
    data: { expectedPermission: 'reservas' },
  },
  {
    path: 'reservas-list',
    component: ModReservasListComponent,
    canActivate: [AuthGuard],
    data: { expectedPermission: 'reservas' },
  },
  {
    path: 'canchas',
    component: ModCanchasComponent,
    canActivate: [AuthGuard],
    data: { expectedPermission: 'canchas' },
  },
  {
    path: 'players',
    component: ModPlayersComponent,
    canActivate: [AuthGuard],
    data: { expectedPermission: 'jugadores' },
  },
  { path: 'players/:id', component: PlayerComponent, canActivate: [AuthGuard] },
  {
    path: 'giveaways',
    component: ModSorteosComponent,
    canActivate: [AuthGuard],
    data: { expectedPermission: 'sorteos' },
  },
  {
    path: 'giveaways/create',
    component: GiveawayDetailComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'giveaways/:id',
    component: GiveawayDetailComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'feedback',
    component: FeedbackMain,
    canActivate: [AuthGuard],
    data: { expectedPermission: 'reservas' },
  },
  {
    path: 'health',
    component: HealthComponent,
    canActivate: [AuthGuard],
    data: { expectedPermission: 'salud' },
  },
  {
    path: 'health/create',
    component: HealthDetailComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'health/:id',
    component: HealthDetailComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'tournaments',
    component: TournamentsListComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'tournaments/create',
    component: CreateTournamentComponent,
    canActivate: [AuthGuard],
  },
  {
    path: 'tournaments/:id',
    component: TournamentDetailComponent,
    canActivate: [AuthGuard],
  },
  { path: '', component: ModReservasComponent, canActivate: [AuthGuard] },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  exports: [RouterModule],
})
export class AppRoutingModule { }
